import {
  Field2 as Field,
} from 'vibeguide';
import Grid from '@mui/material/Grid';

function SystemIntegrator({
  sysIntegrator = '',
  disableInput = false,
  onUpdate = () => {},
}) {
  const onChange = (e) => {
    const {
      target: {
        name,
        value,
      },
    } = e;

    onUpdate({
      [name]: value,
    });
  };

  return (
    <div className="Information info-user">
      <Grid spacing={2} container>
        <Grid size={6}>
          <Field
            type="text"
            label="System Integrator"
            name="integrationName"
            placeholder="System Integrator"
            value={sysIntegrator}
            tabIndex={1}
            disabled={disableInput}
            testId="user-system-integrator-name-input"
            onChange={onChange}
            required
            autoFocus
          />
        </Grid>
      </Grid>
    </div>
  );
}

export default SystemIntegrator;
